import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-14f3e520"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "today-agree-all__title" }
const _hoisted_2 = { class: "today-agree-desc" }
const _hoisted_3 = { class: "today-agree-section__title" }
const _hoisted_4 = { class: "today-agreement-group__body" }
const _hoisted_5 = { class: "today-agreement-group__head" }
const _hoisted_6 = {
  key: 0,
  class: "today-agree-chip"
}
const _hoisted_7 = {
  key: 0,
  class: "today-agree-label"
}
const _hoisted_8 = {
  key: 1,
  class: "today-agree-em"
}
const _hoisted_9 = {
  key: 2,
  class: "today-agree-mark"
}
const _hoisted_10 = {
  key: 0,
  class: "today-agree-figure"
}
const _hoisted_11 = {
  class: "today-agree-flow",
  "aria-hidden": "true"
}
const _hoisted_12 = { class: "today-agree-flow__lag" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "today-agree-flow__line" }, null, -1))
const _hoisted_14 = { class: "today-agree-flow__label" }
const _hoisted_15 = { class: "today-agree-flow__text" }
const _hoisted_16 = { class: "today-agree-example" }
const _hoisted_17 = { class: "today-agree-example__title" }
const _hoisted_18 = { class: "today-agree-example__time" }
const _hoisted_19 = { class: "today-agree-example__text" }
const _hoisted_20 = {
  key: 0,
  class: "today-agree-mark"
}
const _hoisted_21 = { class: "today-agreement" }
const _hoisted_22 = {
  key: 0,
  class: "today-agree-mark"
}
const _hoisted_23 = {
  key: 2,
  class: "text-body-2 text-error",
  role: "alert"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_checkbox_btn = _resolveComponent("v-checkbox-btn")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_card_text = _resolveComponent("v-card-text")!

  return (_openBlock(), _createBlock(_component_v_card_text, { class: "today-agree__body" }, {
    default: _withCtx(() => [
      (_ctx.agreementReady && _ctx.agreementGroups.length)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("label", {
              class: _normalizeClass(["today-agree-all", { 'is-checked': _ctx.allAgreementChecked }])
            }, [
              _createVNode(_component_v_checkbox_btn, {
                modelValue: _ctx.allAgreementChecked,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.allAgreementChecked) = $event)),
                class: "today-agree-check",
                color: "#e8480c",
                density: "compact",
                "aria-label": _ctx.msg.agreementAll
              }, null, 8, ["modelValue", "aria-label"]),
              _createElementVNode("span", null, [
                _createElementVNode("strong", _hoisted_1, _toDisplayString(_ctx.msg.agreementAll), 1),
                _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.msg.agreementAllDesc), 1)
              ])
            ], 2),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.agreementSections, (section) => {
              return (_openBlock(), _createElementBlock("section", {
                key: section.kind,
                class: "today-agree-section"
              }, [
                _createElementVNode("h3", _hoisted_3, _toDisplayString(section.title), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.groups, (entry) => {
                  return (_openBlock(), _createElementBlock("label", {
                    key: entry.index,
                    class: _normalizeClass(["today-agreement-group", { 'today-agreement-group--penalty': entry.group.kind === 'PENALTY', 'is-checked': _ctx.groupChecks[entry.index] }])
                  }, [
                    _createVNode(_component_v_checkbox_btn, {
                      modelValue: _ctx.groupChecks[entry.index],
                      "onUpdate:modelValue": ($event: any) => ((_ctx.groupChecks[entry.index]) = $event),
                      class: "today-agree-check",
                      color: "#e8480c",
                      density: "compact",
                      "aria-label": entry.group.title
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "aria-label"]),
                    _createElementVNode("span", _hoisted_4, [
                      _createElementVNode("span", _hoisted_5, [
                        _createElementVNode("strong", null, _toDisplayString(entry.group.title), 1),
                        (entry.group.important)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.msg.agreementImportant), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("span", {
                        class: _normalizeClass(["today-agree-items", { 'today-agree-items--note': entry.group.kind === 'PENALTY' }])
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(entry.group.items, (item, index) => {
                          return (_openBlock(), _createElementBlock("span", {
                            key: index,
                            class: "today-agree-item"
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.agreementSegments(item), (seg, segIndex) => {
                              return (_openBlock(), _createElementBlock(_Fragment, { key: segIndex }, [
                                (seg.kind === 'label')
                                  ? (_openBlock(), _createElementBlock("strong", _hoisted_7, _toDisplayString(seg.text), 1))
                                  : (seg.kind === 'em')
                                    ? (_openBlock(), _createElementBlock("em", _hoisted_8, _toDisplayString(seg.text), 1))
                                    : (seg.kind === 'mark')
                                      ? (_openBlock(), _createElementBlock("strong", _hoisted_9, _toDisplayString(seg.text), 1))
                                      : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                          _createTextVNode(_toDisplayString(seg.text), 1)
                                        ], 64))
                              ], 64))
                            }), 128))
                          ]))
                        }), 128))
                      ], 2),
                      (entry.figure)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                            _createElementVNode("span", _hoisted_11, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(entry.figure.flow, (cell, cellIndex) => {
                                return (_openBlock(), _createElementBlock("span", {
                                  key: cellIndex,
                                  class: _normalizeClass(["today-agree-flow__cell", { 'today-agree-flow__cell--arrow': cell.arrow }])
                                }, [
                                  (cell.arrow)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createElementVNode("span", _hoisted_12, _toDisplayString(cell.label), 1),
                                        _hoisted_13
                                      ], 64))
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _createElementVNode("span", _hoisted_14, _toDisplayString(cell.label), 1),
                                        _createElementVNode("strong", _hoisted_15, _toDisplayString(cell.text), 1)
                                      ], 64))
                                ], 2))
                              }), 128))
                            ]),
                            _createElementVNode("span", _hoisted_16, [
                              _createElementVNode("span", _hoisted_17, _toDisplayString(entry.figure.example.title), 1),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(entry.figure.example.rows, (row, rowIndex) => {
                                return (_openBlock(), _createElementBlock("span", {
                                  key: rowIndex,
                                  class: _normalizeClass(["today-agree-example__row", { 'is-emphasis': row.emphasis }])
                                }, [
                                  _createElementVNode("strong", _hoisted_18, _toDisplayString(row.time), 1),
                                  _createElementVNode("span", _hoisted_19, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.markedSegments(row.text), (seg, segIndex) => {
                                      return (_openBlock(), _createElementBlock(_Fragment, { key: segIndex }, [
                                        (seg.kind === 'mark')
                                          ? (_openBlock(), _createElementBlock("strong", _hoisted_20, _toDisplayString(seg.text), 1))
                                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                              _createTextVNode(_toDisplayString(seg.text), 1)
                                            ], 64))
                                      ], 64))
                                    }), 128))
                                  ])
                                ], 2))
                              }), 128))
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ], 2))
                }), 128))
              ]))
            }), 128))
          ], 64))
        : (_ctx.agreementReady)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("ul", _hoisted_21, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.agreementItems, (item, index) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: index,
                    class: "text-body-2 mb-3"
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.markedSegments(item), (seg, segIndex) => {
                      return (_openBlock(), _createElementBlock(_Fragment, { key: segIndex }, [
                        (seg.kind === 'mark')
                          ? (_openBlock(), _createElementBlock("strong", _hoisted_22, _toDisplayString(seg.text), 1))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode(_toDisplayString(seg.text), 1)
                            ], 64))
                      ], 64))
                    }), 128))
                  ]))
                }), 128))
              ]),
              _createVNode(_component_v_checkbox, {
                modelValue: _ctx.agreementChecked,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.agreementChecked) = $event)),
                color: "primary",
                "hide-details": "",
                label: _ctx.msg.agreementCheck
              }, null, 8, ["modelValue", "label"])
            ], 64))
          : (_openBlock(), _createElementBlock("p", _hoisted_23, _toDisplayString(_ctx.msg.agreementUnavailable), 1))
    ]),
    _: 1
  }))
}